import { Link } from 'react-router-dom';
import Config from '../../Configuracion/Configuraciones';
import RutasComponente from '../../Configuracion/RutaComponentes';
import ImgError from '../../Activos/Imagenes/NotFound/404.png';
import { Container, Grid, Button } from '@mui/material';
import style, { StyleNotFound } from '../Tool/Style';

import React, { useState, useEffect } from 'react';
import { useStateValue } from '../../Contexto/store';
import DiccionarioEtiquetas from '../../Configuracion/Idiomas/Etiquetas_Diccionario';

const NotFound = () => {

    // contexto de variables globales con el Context Api 
    const [{ etiquetasIdioma }] = useStateValue();

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);


    return (
        <Container maxWidth="xs">
            <div style={style.paper}>
                <img alt="..." src={ImgError} className={StyleNotFound.Avatar} />
            </div>
            <form style={style.form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} >
                        <Button type="Submit" fullWidth variant="contained" style={style.submit} color="primary" size="large"  >
                            <Link style={{ textDecoration: 'none', color: 'inherit' }} to={Config.rutaPublicacion + RutasComponente.RutaHome.path} > {etiquetas.EtiquetasComponente.NotFound.Et_btnAccion}</Link>
                        </Button>
                    </Grid>
                </Grid>
            </form>

        </Container>
    );
};

export default NotFound;